import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useSite } from "@/context/SiteContext";

import Home from "@/pages/Home";
import Jobs from "@/pages/Jobs";
import JobDetail from "@/pages/JobDetail";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Industries from "@/pages/Industries";
import IndustryDetail from "@/pages/IndustryDetail";
import Locations from "@/pages/Locations";
import LocationDetail from "@/pages/LocationDetail";
import Blog from "@/pages/Blog";
import BlogDetail from "@/pages/BlogDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import ForEmployers from "@/pages/ForEmployers";
import ForJobSeekers from "@/pages/ForJobSeekers";
import CandidateRegistration from "@/pages/CandidateRegistration";
import SubmitResume from "@/pages/SubmitResume";
import Login from "@/pages/Login";
import CandidateDashboard from "@/pages/candidate/CandidateDashboard";
import EmployerRegistration from "@/pages/employer/EmployerRegistration";
import EmployerDashboard from "@/pages/employer/EmployerDashboard";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";

import ProtectedRoute from "@/components/ProtectedRoute";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Collection from "@/pages/admin/Collection";
import AdminSettings from "@/pages/admin/Settings";

function Analytics() {
  const { settings } = useSite();
  useEffect(() => {
    if (settings.ga4_id && !window.__ga_loaded) {
      window.__ga_loaded = true;
      const s = document.createElement("script");
      s.async = true; s.src = `https://www.googletagmanager.com/gtag/js?id=${settings.ga4_id}`;
      document.head.appendChild(s);
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () { window.dataLayer.push(arguments); };
      window.gtag("js", new Date());
      window.gtag("config", settings.ga4_id);
    }
    if (settings.gtm_id && !window.__gtm_loaded) {
      window.__gtm_loaded = true;
      (function (w, d, s, l, i) {
        w[l] = w[l] || []; w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
        const f = d.getElementsByTagName(s)[0], j = d.createElement(s);
        j.async = true; j.src = "https://www.googletagmanager.com/gtm.js?id=" + i;
        f.parentNode.insertBefore(j, f);
      })(window, document, "script", "dataLayer", settings.gtm_id);
    }
  }, [settings]);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <Analytics />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/jobs" element={<Jobs />} />
        <Route path="/job/:slug" element={<JobDetail />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:slug" element={<ServiceDetail />} />
        <Route path="/industries" element={<Industries />} />
        <Route path="/industries/:slug" element={<IndustryDetail />} />
        <Route path="/locations" element={<Locations />} />
        <Route path="/locations/:slug" element={<LocationDetail />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogDetail />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/for-employers" element={<ForEmployers />} />
        <Route path="/for-job-seekers" element={<ForJobSeekers />} />
        <Route path="/candidate-registration" element={<CandidateRegistration />} />
        <Route path="/submit-resume" element={<SubmitResume />} />
        <Route path="/login" element={<Login />} />
        <Route path="/candidate/dashboard" element={<ProtectedRoute roles={["candidate"]}><CandidateDashboard /></ProtectedRoute>} />
        <Route path="/employer-registration" element={<EmployerRegistration />} />
        <Route path="/employer/dashboard" element={<ProtectedRoute roles={["employer"]}><EmployerDashboard /></ProtectedRoute>} />
        <Route path="/privacy-policy" element={<Legal page="privacy-policy" />} />
        <Route path="/terms" element={<Legal page="terms" />} />
        <Route path="/disclaimer" element={<Legal page="disclaimer" />} />
        <Route path="/cookie-policy" element={<Legal page="cookie-policy" />} />

        <Route path="/admin" element={<ProtectedRoute roles={["admin", "staff"]}><AdminLayout /></ProtectedRoute>}>
          <Route index element={<Dashboard />} />
          <Route path="settings" element={<AdminSettings />} />
          <Route path=":name" element={<Collection />} />
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
